import React from 'react';
import { Link } from 'react-router-dom';
import RouteConstants from '../../../../utils/RouteConstants';
import HighlightList from '../../../common/marketing/HighlightList';
import SectionHeader from '../../../common/marketing/SectionHeader';
import { renderMarketingIcon } from '../../../../utils/marketingIcons';
import pageAssets from '../../../../data/pageAssets';
import AppImage from '../../../common/media/AppImage';

const WireBrandSection = ({ sectionClassName, sectionId, data, variant }) => {
    if (variant === 'indrason') {
        return (
            <section id={sectionId} className={sectionClassName}>
                <div className="container">
                    <div className="about-wires-section-header">
                        <div className="indrason-section-subtitle">{data.subtitle}</div>
                        <div className="indrason-logo-container">
                            <AppImage src={pageAssets[data.logoImageKey]} alt={data.logoImageAlt} className="indrason-logo-img" />
                        </div>
                        <p className="indrason-section-desc">{data.description}</p>
                    </div>

                    <div className="indrason-hero-banner">
                        <AppImage src={pageAssets[data.bannerImageKey]} alt={data.bannerImageAlt} />
                    </div>

                    <div className="indrason-features-grid">
                        {data.features.map((item) => (
                            <div key={item.title} className="indrason-feature-card">
                                <div className="indrason-feature-icon">{renderMarketingIcon(item.icon)}</div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="indrason-showcase-grid">
                        <div className="indrason-showcase-image">
                            <AppImage src={pageAssets[data.showcaseImageKey]} alt={data.showcaseImageAlt} />
                        </div>
                        <div className="indrason-showcase-content">
                            <div className="indrason-section-subtitle" style={{ textAlign: 'left' }}>{data.showcaseSubtitle}</div>
                            <h2>{data.showcaseTitlePrefix} <span>{data.showcaseTitleHighlight}</span> {data.showcaseTitleSuffix}</h2>
                            <p className="indrason-showcase-text">{data.showcaseDescription}</p>
                            <HighlightList
                                items={data.highlights}
                                listClassName="indrason-highlights"
                                itemClassName="indrason-highlight-item"
                                iconWrapperClassName="indrason-highlight-check"
                            />
                            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                {data.detailRoute ? (
                                    <Link to={data.detailRoute} className="btn btn-outline btn-lg">{
                                        data.detailLabel || 'Learn More'
                                    }</Link>
                                ) : null}
                                <button type="button" className="btn indrason-btn-primary btn-lg" onClick={data.onCtaClick}>{data.ctaLabel}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section id={sectionId} className={sectionClassName}>
            <div className="container">
                <SectionHeader
                    wrapperClassName="about-wires-section-header"
                    subtitleClassName="about-wires-section-subtitle"
                    titleClassName="about-wires-section-title"
                    descriptionClassName="heatshield-section-desc"
                    subtitle={data.subtitle}
                    title={data.title}
                    description={data.description}
                />

                <div className="heatshield-hero-banner">
                    <AppImage src={pageAssets[data.bannerImageKey]} alt={data.bannerImageAlt} />
                </div>

                <div className="heatshield-features-grid">
                    {data.features.map((item) => (
                        <div key={item.title} className="heatshield-feature-card">
                            <div className="heatshield-feature-icon">{renderMarketingIcon(item.icon)}</div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>

                <div className="heatshield-showcase-grid">
                    <div className="heatshield-showcase-image">
                        <AppImage src={pageAssets[data.showcaseImageKey]} alt={data.showcaseImageAlt} />
                    </div>
                    <div className="heatshield-showcase-content">
                        <div className="about-wires-section-subtitle" style={{ textAlign: 'left' }}>{data.showcaseSubtitle}</div>
                        <h2>{data.showcaseTitlePrefix} <span>{data.showcaseTitleHighlight}</span> {data.showcaseTitleSuffix}</h2>
                        <p className="heatshield-showcase-text">{data.showcaseDescription}</p>
                        <HighlightList
                            items={data.highlights}
                            listClassName="about-wires-highlights"
                            itemClassName="about-wires-highlight-item"
                            iconWrapperClassName="about-wires-highlight-check"
                        />
                        <Link to={`${RouteConstants.WIRES}#wire-catalog`} className="btn btn-primary btn-lg">{data.ctaLabel}</Link>
                    </div>
                </div>

                <div className="heatshield-product-hero">
                    <AppImage src={pageAssets[data.heroImageKey]} alt={data.heroImageAlt} />
                </div>
            </div>
        </section>
    );
};

export default WireBrandSection;
